export const getFocusableElements = (parent: HTMLElement): NodeListOf<HTMLElement> =>
    parent.querySelectorAll('a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])');
